export const COLOR_SCHEMES = {
  dark: {
    bar: {
      top: "#3E3F41",
      bottom: "#343435"
    },
    button: {
      top: "#737375",
      bottom: "#6b6b6d",
      text: "#fafafc",
      disabledText: "#98989a",
      strokeWidth: 0,
      strokeColor: undefined
    },
    text: "#fdfdfd"
  },
  light: {
    bar: {
      top: "#e5e5e4",
      bottom: "#cdcdcd"
    },
    button: {
      top: "#fefefe",
      bottom: "#efefef",
      text: "#808080",
      disabledText: "#c6c6c6",
      strokeWidth: 1,
      strokeColor: "#d3d1d3"
    },
    text: "#535353"
  }
};
